import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import { Chip } from '@mui/material';
import type { GridRenderCellParams } from '@mui/x-data-grid-pro';

const ControlOptionChip = ({ value }: GridRenderCellParams<IControlOption>) => {
  return <Chip variant='outlined' label={value?.label} />;
};

export default ControlOptionChip;
